<template>
    <button class="mx-1" :class="buttonClasses" @click="onSaveClick" style="min-width: 120px;">
        {{ component.value }}
    </button>
</template>

<script>
import DataService from "../../services/DataService";

export default {
    name: 'SaveButton',
    props: ['component', 'table', 'document', 'cssFramework'],
    computed: {
        buttonClasses() {
            if (this.cssFramework === 'Tailwind') {
                return 'px-4 py-2 rounded bg-violet-600 text-white shadow-md hover:bg-violet-700'
            }

            return `btn btn-${this.buttonTheme}`
        },
        buttonTheme() {
            return this.component.style && this.component.style.color ? this.component.style.color : 'success'
        }
    },
    data() {
        return {
            model: webase.model,
            service: new DataService(this.table.id)
        }
    },
    mounted() {
    },
    methods: {
        onSaveClick() {

            this.service.save(this.document).then((response) => {
                console.log('save complete')
                console.log(response)
                this.$router.go(-1)
            }).catch((message) => {
                console.log('error saving document')
                console.log(message)
            })
        }
    }
}
</script>

<style>

</style>
